import { render, staticRenderFns } from "./DisabledTextField.vue?vue&type=template&id=189f9529"
import script from "./DisabledTextField.vue?vue&type=script&lang=js"
export * from "./DisabledTextField.vue?vue&type=script&lang=js"
import style0 from "./DisabledTextField.vue?vue&type=style&index=0&id=189f9529&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports